module.exports = __webpack_public_path__ + "img/Arthritis-02.5e22d84d.svg";